import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import LandingPageView from "@/views/LandingPageView.vue";
import FeaturesView from "@/views/FeaturesView.vue";
import PrivacyPolicyView from "@/views/PrivacyPolicyView.vue";
import CookiePolicyView from "@/views/CookiePolicyView.vue";
import CompanyView from "@/views/CompanyView.vue";
import SupportView from "@/views/SupportView.vue";
import B2BView from "@/views/B2BView.vue";

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: LandingPageView,
  },
  {
    path: '/features',
    name: 'features',
    component: FeaturesView,
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicyView,
  },
  {
    path: '/cookie-policy',
    name: 'cookie-policy',
    component: CookiePolicyView,
  },
	{
		path: '/company',
		name: 'company',
		component: CompanyView,
	},
	{
		path: '/b2b',
		name: 'b2b',
		component: B2BView,
	},

	{
		path: '/support',
		name: 'support',
		component: SupportView,
	},
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0, left: 0 }
    }
  },
})

router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router
